import { useState, useEffect } from "react";
import api from "../api/api";
import Modal from "../components/modal";

// 🎨 SUPER PALETA DE CORES (Unimos Tarefas e Agenda)
const categoryColors = {
  "Financeiro": "bg-rose-50 text-rose-700 border-rose-200 hover:bg-rose-100",
  "Compras": "bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100",
  "Toner": "bg-teal-50 text-teal-700 border-teal-200 hover:bg-teal-100",
  "Serviço": "bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100",
  "Venda": "bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100",
  "Instalação": "bg-purple-50 text-purple-700 border-purple-200 hover:bg-purple-100",
  "Manutenção": "bg-indigo-50 text-indigo-700 border-indigo-200 hover:bg-indigo-100",
  "Outros": "bg-slate-100 text-slate-700 border-slate-300 hover:bg-slate-200"
};

export default function CalendarPage() {
  const [events, setEvents] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [eventForm, setEventForm] = useState({ 
    id: null, title: "", date: "", category: "Manutenção", description: "" 
  });

  const today = new Date();
  const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;

  const fetchEvents = async () => {
    try {
      const res = await api.get("/calender");
      setEvents(Array.isArray(res.data) ? res.data : []);
    } catch (err) { console.error("Erro ao buscar eventos", err); }
  };

  useEffect(() => { fetchEvents(); }, []);

  const handleOpenAdd = () => {
    setEventForm({ id: null, title: "", date: "", category: "Manutenção", description: "" });
    setIsModalOpen(true);
  };

  const handleOpenEdit = (event) => {
    const cleanTitle = event.title.startsWith("[TAREFA]") ? event.title.replace("[TAREFA] ", "") : event.title;
    setEventForm({
      id: event.id, 
      title: cleanTitle, 
      date: event.date,
      category: event.category || "Manutenção", 
      description: event.description || ""
    });
    setIsModalOpen(true);
  };

  const handleSave = async () => {
    if (!eventForm.title || !eventForm.date) return alert("Preencha título e data!");
    const payload = {
      title: eventForm.title,
      description: eventForm.description || "",
      event_date: eventForm.date, 
      category: eventForm.category
    };

    try {
      if (eventForm.id) {
        await api.put(`/calender/${eventForm.id}`, payload);
      } else {
        await api.post("/calender", payload);
      }
      setIsModalOpen(false);
      fetchEvents(); 
    } catch (err) {
      alert("Erro ao salvar o evento.");
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Excluir este compromisso?")) {
      try {
        await api.delete(`/calender/${eventForm.id}`);
        setIsModalOpen(false);
        fetchEvents();
      } catch (err) { alert("Erro ao excluir"); }
    }
  };

  const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay();
  const days = Array.from({ length: getDaysInMonth(currentDate.getFullYear(), currentDate.getMonth()) }, (_, i) => i + 1);

  return (
    <div className="p-2 md:p-8 animate-in fade-in duration-500 bg-[#f8fafc] min-h-screen pb-24 md:pb-8">
      
      {/* HEADER ADAPTÁVEL */}
      <div className="bg-white p-4 md:p-8 rounded-[25px] md:rounded-[30px] border border-slate-200 shadow-sm flex flex-col md:flex-row justify-between items-center gap-4 mb-6">
        <div className="flex flex-col sm:flex-row items-center gap-3 w-full md:w-auto">
          <button onClick={handleOpenAdd} className="w-full sm:w-auto bg-indigo-600 text-white px-6 py-4 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-slate-900 transition-all shadow-lg shadow-indigo-600/20 active:scale-95">
            + Adicionar
          </button>
          <h2 className="text-xl md:text-3xl font-black text-slate-800 uppercase tracking-tighter text-center">
            {currentDate.toLocaleString('pt-BR', { month: 'long', year: 'numeric' })}
          </h2>
        </div>
        
        <div className="flex gap-2 bg-slate-100 p-1.5 rounded-xl shadow-inner w-full sm:w-auto justify-center">
          <button onClick={() => setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() - 1)))} className="px-4 py-2 bg-white rounded-lg shadow-sm hover:bg-indigo-600 hover:text-white transition-all font-black text-slate-400">←</button>
          <button onClick={() => setCurrentDate(new Date())} className="px-6 py-2 bg-white rounded-lg shadow-sm hover:bg-slate-900 hover:text-white transition-all text-[9px] font-black uppercase text-slate-500">Hoje</button>
          <button onClick={() => setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() + 1)))} className="px-4 py-2 bg-white rounded-lg shadow-sm hover:bg-indigo-600 hover:text-white transition-all font-black text-slate-400">→</button>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row gap-6">
        {/* SIDEBAR DE LEGENDAS - Vira pílulas no mobile */}
        <div className="w-full lg:w-64 shrink-0 bg-white p-6 md:p-8 rounded-[25px] md:rounded-[30px] border border-slate-200 shadow-sm h-fit">
          <h3 className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-4 flex items-center gap-2">🏷️ Categorias</h3>
          <ul className="flex flex-wrap lg:flex-col gap-2 md:gap-4">
            {Object.keys(categoryColors).map(cat => (
              <li key={cat} className="flex items-center gap-2 text-[9px] md:text-[11px] font-black text-slate-600 uppercase bg-slate-50 lg:bg-transparent p-2 lg:p-0 rounded-lg border lg:border-0">
                <span className={`w-3 h-3 md:w-4 md:h-4 rounded-md border shadow-sm shrink-0 ${categoryColors[cat].split(' ')[0]}`}></span> 
                {cat}
              </li>
            ))}
          </ul>
        </div>

        {/* CALENDÁRIO GRID */}
        <div className="flex-1 bg-white rounded-[25px] md:rounded-[40px] border border-slate-200 shadow-sm overflow-hidden">
          {/* DIAS DA SEMANA */}
          <div className="grid grid-cols-7 bg-slate-50/80 border-b border-slate-100">
            {['D', 'S', 'T', 'Q', 'Q', 'S', 'S'].map((d, i) => (
              <div key={i} className="p-3 md:p-4 text-center text-[10px] font-black text-slate-400 uppercase tracking-widest border-r border-slate-100 last:border-0">
                <span className="hidden md:inline">{['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'][i]}</span>
                <span className="md:hidden">{d}</span>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-7">
            {/* Espaços vazios do início do mês */}
            {Array(firstDayOfMonth).fill(null).map((_, i) => (
              <div key={i} className="min-h-[80px] md:min-h-[140px] bg-slate-50/30 border-b border-r border-slate-100"></div>
            ))}

            {days.map(day => {
              const dateStr = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
              const isToday = dateStr === todayStr; 
              const dayEvents = events.filter(e => e.date === dateStr);

              return (
                <div 
                  key={day} 
                  className={`min-h-[80px] md:min-h-[140px] p-1 md:p-2 border-b border-r border-slate-100 transition-all relative ${isToday ? 'bg-indigo-50/30 shadow-[inset_0_4px_20px_rgba(79,70,229,0.05)]' : 'hover:bg-slate-50/20'}`}
                >
                  <span className={`text-[10px] md:text-xs font-black absolute top-1.5 md:top-3 right-2 md:right-4 ${isToday ? 'text-indigo-600 bg-indigo-100 px-1.5 py-0.5 rounded-md' : 'text-slate-300'}`}>
                    {day}
                  </span>
                  
                  <div className="mt-6 md:mt-10 space-y-1 overflow-y-auto max-h-[60px] md:max-h-[100px] custom-scrollbar">
                    {dayEvents.map((e, idx) => {
                      const isTask = e.title.startsWith("[TAREFA]");
                      const displayTitle = isTask ? e.title.replace("[TAREFA] ", "📌 ") : e.title;

                      return (
                        <div 
                          key={idx} 
                          onClick={() => handleOpenEdit(e)}
                          className={`text-[8px] md:text-[9px] p-1.5 md:p-2 rounded-lg font-black truncate uppercase border cursor-pointer hover:brightness-95 transition-all shadow-sm ${categoryColors[e.category] || categoryColors.Outros}`}
                          title={displayTitle}
                        >
                          <span className="md:hidden">{isTask ? "📌" : "•"}</span>
                          <span className="hidden md:inline">{displayTitle}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* MODAL RESPONSIVO */}
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <div className="p-1 md:p-2">
            <h2 className="text-2xl md:text-3xl font-black mb-1 uppercase tracking-tighter text-slate-800">{eventForm.id ? "Editar" : "Novo"} Evento</h2>
            <p className="text-[10px] font-black text-indigo-600 uppercase mb-6 tracking-[0.2em]">Agenda de Bancada</p>
            
            <div className="space-y-4">
                <input placeholder="Título" className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-black uppercase text-slate-700 outline-none focus:border-indigo-400 transition-all" value={eventForm.title} onChange={e => setEventForm({...eventForm, title: e.target.value})} />
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <input type="date" className="p-4 bg-slate-50 border border-slate-200 rounded-xl font-black text-slate-700 outline-none focus:border-indigo-400 transition-all cursor-pointer" value={eventForm.date} onChange={e => setEventForm({...eventForm, date: e.target.value})} />
                    
                    <select className="p-4 bg-slate-50 border border-slate-200 rounded-xl font-black uppercase text-[10px] text-slate-700 outline-none focus:border-indigo-400 transition-all cursor-pointer tracking-widest" value={eventForm.category} onChange={e => setEventForm({...eventForm, category: e.target.value})}>
                        <option value="Serviço">Serviço</option>
                        <option value="Venda">Venda</option>
                        <option value="Manutenção">Manutenção</option>
                        <option value="Instalação">Instalação</option>
                        <option value="Financeiro">Financeiro</option>
                        <option value="Compras">Compras</option>
                        <option value="Toner">Toner</option>
                        <option value="Outros">Outros</option>
                    </select>
                </div>
                
                <textarea placeholder="Descrição rápida..." className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl font-bold text-slate-700 h-24 md:h-32 resize-none outline-none focus:border-indigo-400 transition-all" value={eventForm.description} onChange={e => setEventForm({...eventForm, description: e.target.value})} />
                
                <div className="flex gap-3 pt-4 border-t border-slate-100">
                    <button onClick={handleSave} className="flex-1 py-5 bg-slate-900 text-white font-black rounded-2xl uppercase text-[10px] tracking-widest hover:bg-indigo-600 transition-all active:scale-95">Salvar 💾</button>
                    {eventForm.id && <button onClick={handleDelete} className="w-16 bg-rose-50 text-rose-500 font-black rounded-2xl text-lg hover:bg-rose-500 hover:text-white transition-all border border-rose-100 flex items-center justify-center">🗑️</button>}
                </div>
            </div>
          </div>
      </Modal>
    </div>
  );
}